import { BASE_URL } from '@/config';

export const apiGlobalConstants = {
  profile: `${BASE_URL}/api/profile`,
  data: `${BASE_URL}/api/data`,
  auth: `${BASE_URL}/auth`,
  utils: `${BASE_URL}/utils`
}